// extracted by mini-css-extract-plugin
var _1 = "CalendarRailView-moduletitle__FSPcx";
export { _1 as "title" }
